/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type settingsApiKeys_apiKey$ref: FragmentReference;
declare export opaque type settingsApiKeys_apiKey$fragmentType: settingsApiKeys_apiKey$ref;
export type settingsApiKeys_apiKey = {|
  +id: string,
  +name: ?string,
  +key: ?string,
  +active: ?boolean,
  +createdAt: ?string,
  +createdBy: ?{|
    +id: string,
    +firstName: ?string,
    +lastName: ?string,
  |},
  +$refType: settingsApiKeys_apiKey$ref,
|};
export type settingsApiKeys_apiKey$data = settingsApiKeys_apiKey;
export type settingsApiKeys_apiKey$key = {
  +$data?: settingsApiKeys_apiKey$data,
  +$fragmentRefs: settingsApiKeys_apiKey$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsApiKeys_apiKey",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ApiKey"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b087163108405b6fa625b687fae436f3';

module.exports = node;
